import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import React from "react";
import { Row, Col, Avatar } from "antd";
import {
  FacebookFilled,
  TwitterSquareFilled,
  LinkedinFilled,
  LinkOutlined,
} from "@ant-design/icons";
import bannerImage3 from "../../assets/echoo.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";

const SubscriptionModel = () => {
  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          // style={{
          //   background: `url(${bannerImage3}) no-repeat center center/cover`,
          // }}
          style={{
            backgroundColor: "black",
          }}
        >
          <h1>
            What’s the Real Cost of Free? Why {BRAND.domainLabel} Chose a Subscription
            Model Over Ads
          </h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <Avatar size={64} src="https://thispersondoesnotexist.com/" />

                  <div className={styles.authorText}>
                    <h3>Harleen Cook</h3>
                    <p></p>
                  </div>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on May 29, 2025</p>
                <h1 className={styles.postTitle}>
                  What’s the Real Cost of Free? Why {BRAND.domainLabel} Chose a
                  Subscription Model Over Ads
                </h1>
                <p className={styles.author}>By Harleen Cook</p>
              </div>
              <div className={styles.contents}>
                <h4>Contents</h4>
                <ul>
                  <li>
                    <a href="#letter">A letter from Harleen & Andrew</a>
                  </li>
                  <li>
                    <a href="#free">The Price of “Free” Is Your Mind</a>
                  </li>
                  <li>
                    <a href="#tech">Even Tech Bosses Know the Dangers</a>
                  </li>
                  <li>
                    <a href="#subscriptions">
                      Subscriptions: Paying for Protection, Not Popularity
                    </a>
                  </li>
                  <li>
                    <a href="#Change">
                      Society Says It Wants Change—But Are We Willing to Pay for
                      It?
                    </a>
                  </li>
                  <li>
                    <a href="#platform">
                      A Platform Designed for Real Value, Not Viral Value
                    </a>
                  </li>

                  <li>
                    <a href="#future">
                      The Future We Deserve—One Subscription, One Voice, One
                      Value at a Time
                    </a>
                  </li>

                  <li>
                    <a href="#references">References</a>
                  </li>
                </ul>
              </div>

              <div className={styles.share}>
                <h4>Share This Blog</h4>
                <div className={styles.icons}>
                  <FacebookFilled />
                  <TwitterSquareFilled />
                  <LinkedinFilled />
                  <LinkOutlined />
                </div>
              </div>
            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            <div className={styles.articleWrapper}>
              <p className={styles.intro} id="letter">
                <strong>
                  A letter from Harleen & Andrew, founders of The Buddyhood Ltd
                  and {BRAND.domainLabel}
                </strong>
              </p>
              <p className={styles.intro} id="letter">
                <em>
                  Self-respect and dignity are core to who we are and how we
                  teach are children to stand up for themselves. They define our
                  self-worth, which is uncompromisable. It is measured by our
                  words, our actions and by how we spend our time-our attention.
                  The latter decides what our brand is and what we stand for.
                </em>
              </p>

              <p>
                Yet online, respect and dignity are exploited, as attention is
                mined from us and sold. Why do tech companies want our attention
                so much? If it's so valuable then why are we left exposed,
                unprotected and feeling worthless? This is because we willingly
                accept the notion that social media is, and should be, “free”.
                But is it really? What we see as a bargain actually comes with
                some very hefty hidden costs.
              </p>

              {/* <img
                src="/Images/brainworks.png"
                alt="Brain in a cage"
                className={styles.featureImage}
              /> */}

              <h2 id="free">The Price of “Free” Is Your Mind</h2>
              <p>
                When a product is free, the business must make money elsewhere.
                Usually, that's advertising, but to sell ads, you need eyeballs,
                and not just for a few seconds.
              </p>
              <p>You need people addicted.</p>
              <p>
                Which is why most social media platforms aren't just showing you
                content. They're designing it to hijack your brain.
              </p>
              <p>
                Infinite scroll. Autoplay. Notifications. Personalised feeds.
                All optimised by algorithms that learn what keeps you
                watching—then feed you more of it, whether or not it's good for
                you.
              </p>
              <p>
                A 2024 report by the Centre for Humane Technology called this
                what it is:
              </p>
              <p>
                <em>
                  “Algorithmic exploitation of the human psyche. What used to be
                  marketing has become psychological warfare.”
                </em>
              </p>

              <p>
                Young people are especially vulnerable. Their sense of identity,
                focus, and value is being shaped by tech designed to keep them
                scrolling—not to help them grow.
              </p>
              <p>
                The NHS reported a 30% increase in teen attention disorders
                linked directly to excessive algorithmic exposure (2023).
                Self-harm, anxiety, and comparison-driven depression are at an
                all-time high. These platforms aren't neutral. They're not safe.
                They're not free. We pay for it the harm it causes through our
                taxes.
              </p>

              <h2 id="tech">Even Tech Bosses Know the Dangers </h2>
              <p>
                You know something’s deeply wrong when tech executives are
                highlighting the dangers posed to children from their own
                products and industries.
              </p>
              <ul className={styles.references}>
                <li>
                  Tim Cook, Apple CEO, has said he doesn’t let his nephew on
                  social media.
                </li>
                <li>
                  Chamath Palihapitiya, former Facebook executive, said he felt
                  “tremendous guilt” for helping build a system that is “ripping
                  apart the social fabric of how society works”.
                </li>
                <li>
                  Sean Parker, Facebook's first president, has been candid about
                  the platform's design to exploit human psychology. He stated:
                  "God only knows what it's doing to our children's brains."
                </li>
              </ul>
              <p>
                They know what these platforms are doing—because they built
                them.
              </p>
              <p>
                While they may shelter their children, millions of others are
                left exposed. Not just to ads, but to manipulation,
                polarisation, bullying, and predatory content dressed up as
                entertainment.
              </p>
              <p>This isn't innovation. It's exploitation.</p>

              <h2 id="subscriptions">
                Subscriptions: Paying for Protection, Not Popularity
              </h2>
              <p>So why does {BRAND.domainLabel} ask for a subscription?</p>
              <p>
                Safety doesn't scale for free. Responsibility comes with
                real-world cost.
              </p>
              <p>
                We pay for safety in all other aspects of our lives - installing
                burglar alarms, anti-virus software or taking out insurance.
                Also, we are accustomed to paying for a quality product; one
                that has had time taken over it, is healthier and makes us feel
                valued. At {BRAND.domainLabel}:
              </p>
              <p>
                <strong>Every post is pre-moderated for safety.</strong>
              </p>
              <p>
                <strong>No data is sold. No attention is mined.</strong>
              </p>
              <p>
                <strong>There are no comments.</strong>
              </p>
              <p>
                <strong>
                  All users are verified through bank details—meaning
                  accountability, not anonymity.
                </strong>
              </p>
              <p>
                This means trolls can't hide behind fake emails. It means that
                if someone causes harm, there is a trail, a name, a consequence.
                That's what real-world safety looks like, and it's what we've
                replicated online.
              </p>
              <p>
                The small subscription also allows users to tie financial worth
                to human worth—because a portion of every subscription supports
                mental health projects, build compassionate communities and save
                lives through a charitable donation. This is the offset to the
                cost we are incurring as a society from other social media
                platforms, without us knowing.
              </p>
              <p>
                You're not just paying to use a platform. You're investing in
                yourself—and in someone else's second chance.
              </p>

              <h2 id="Change">
                Society Says It Wants Change—But Are We Willing to Pay for It?
              </h2>
              <p>We’ve heard it all before:</p>
              <ul className={styles.references}>
                <li>“Social media is toxic.”</li>
                <li>“My kids spend too much time online.”</li>
                <li>“Why is there so much hate on the internet?”</li>
              </ul>
              <p>
                Yet, when asked to pay £2 or £5 a month for a safer space, many
                hesitate.
              </p>
              <p>
                But consider this: The cost of a subscription is less than a
                coffee. The cost of doing nothing is:
              </p>

              <ul className={styles.references}>
                <li>A rise in teenage suicides.</li>
                <li>A generation with no attention span.</li>
                <li>
                  Children growing up believing that their worth is defined by
                  followers, filters, and fake perfection. y
                </li>
              </ul>
              <p>Is this the future we want?</p>
              <p>
                The uncomfortable truth is: real freedom of expression,
                responsibility, and dignity requires structure, effort, and
                investment. Free platforms don't offer that—because they don't
                work for you. They work for advertisers.
              </p>
              <p>At {BRAND.domainLabel}, we work for you.</p>

              <h2 id="platform">
                A Platform Designed for Real Value, Not Viral Value
              </h2>
              <p>
                We built {BRAND.domainLabel} with intention because we wanted a space
                where:
              </p>
              <ul className={styles.references}>
                <li>Young people could express themselves without fear.</li>
                <li>
                  Parents could trust that safety was baked into the structure.
                </li>
                <li>Every story told had the potential to heal—not harm.</li>
              </ul>
              <p>
                There's no pressure to perform and there's no reward for
                outrage. Instead, you'll find:
              </p>

              <ul className={styles.references}>
                <li>
                  Honest reflections, tied to values like safety, purpose and
                  love.
                </li>
                <li>No comments—just space to breathe.</li>
                <li>
                  Verified users—so you know you’re not shouting into a void of
                  bots or burners.
                </li>
              </ul>
              <p>It’s not about trends. It’s about truth.</p>

              <h2 id="future">
                The Future We Deserve—One Subscription, One Voice, One Value at
                a Time
              </h2>
              <p>We believe in a world where:</p>
              <ul className={styles.references}>
                <li>
                  Teenagers can explore who they are without being exploited.
                </li>
                <li>Adults can express themselves without fear.</li>
                <li>
                  People who feel worthless can remember they have worth—not
                  because of likes, but because of the impact they can make
                  through the charitable donations.
                </li>
              </ul>
              <p>That's what your subscription funds.</p>
              <p>That's the power of value.</p>
              <p>That's the power of integrity.</p>
              <p>Thatts the power of you.</p>

              <p>
                <strong>— Harleen & Andrew</strong>
                <br />
                Founders of The Buddyhood Ltd and {BRAND.domainLabel}
              </p>
              <h3 id="references"> References</h3>
              <ul className={styles.references}>
                <li>
                  Centre for Humane Technology (2024). The Attention Economy and
                  its Weaponisation
                </li>
                <li>
                  NHS Digital (2023). Young People and Mental Health in the
                  Digital Age
                </li>
                <li>
                  BBC (2020). Tech Executives on Limiting Their Children’s
                  Screen Time
                </li>
                <li>
                  The Guardian (2021). Why Big Tech Doesn’t Let Their Kids Use
                  the Products They Build
                </li>
                <li>
                  Children’s Commissioner for England (2023). Safer Digital
                  Spaces: What Children and Parents Want
                </li>
                <li>
                  The Times (2024). Parents Call for Regulated Platforms: Are We
                  Ready to Pay for It?
                </li>
              </ul>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default SubscriptionModel;
